module.exports = __webpack_public_path__ + "img/horizontal_line_filtered_hover.0c0c2f70.svg";